/**
 * RecentIntelligence — CCD-DASH-014 Phase A · R5 (minimal stub).
 *
 * Editorial feed of curated changes on the voyage. Cruise Command's
 * *point of view* — port briefs published, party actions, excursion
 * price changes, expiring documents. For Phase A, sources the existing
 * `today.planning_block.recent_activity[]` stream. Phase C polishes.
 *
 * Design: /app/docs/design/CCD-DASH-014-dashboard-design-sprint.md §1.1 · R5
 */
import React from "react";
import { Sparkles } from "lucide-react";
import HomeSummaryCard from "./HomeSummaryCard";

function _timeAgo(iso) {
  if (!iso) return "";
  try {
    const then = new Date(iso).getTime();
    const now = Date.now();
    const mins = Math.round((now - then) / 60000);
    if (mins < 1) return "just now";
    if (mins < 60) return `${mins}m ago`;
    const hrs = Math.round(mins / 60);
    if (hrs < 24) return `${hrs}h ago`;
    const days = Math.round(hrs / 24);
    if (days < 7) return `${days}d ago`;
    return new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric" });
  } catch { return ""; }
}

export function RecentIntelligence({ activity }) {
  const rows = Array.isArray(activity) ? activity.slice(0, 5) : [];

  return (
    <HomeSummaryCard
      eyebrow="Recent Intelligence"
      icon={<Sparkles className="w-3 h-3" />}
      title="What's changed on your voyage"
      testId="recent-intelligence-card"
    >
      {rows.length === 0 ? (
        <div className="font-body text-[13px] text-slate-500 leading-relaxed">
          No recent changes. New activity — briefs, bookings, price shifts — will surface here.
        </div>
      ) : (
        <ul className="divide-y divide-slate-100" data-testid="recent-intelligence-list">
          {rows.map((a, i) => (
            <li key={a.id || i} className="py-2.5 flex items-start gap-3">
              <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-slate-400 shrink-0" aria-hidden="true" />
              <div className="flex-1 min-w-0">
                <div className="font-body text-[13px] text-slate-800 leading-snug">
                  {a.title || a.label || a.kind}
                </div>
                {a.subtitle && (
                  <div className="font-body text-[11px] text-slate-500 leading-snug">
                    {a.subtitle}
                  </div>
                )}
              </div>
              <span className="font-body text-[11px] text-slate-400 shrink-0 tabular-nums">
                {_timeAgo(a.at || a.at_iso || a.created_at)}
              </span>
            </li>
          ))}
        </ul>
      )}
    </HomeSummaryCard>
  );
}

export default RecentIntelligence;
